import { render, staticRenderFns } from "./ReporteOcupacion.vue?vue&type=template&id=3ec51302&"
import script from "./ReporteOcupacion.vue?vue&type=script&lang=js&"
export * from "./ReporteOcupacion.vue?vue&type=script&lang=js&"
import style0 from "./ReporteOcupacion.vue?vue&type=style&index=0&id=3ec51302&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports